import React from 'react';
import DateInput from '@/shared/components/forms/DateInput';
import SearchableSelect, { SelectOption } from '@/shared/components/forms/SearchableSelect';
import { formatCurrency } from '@/shared/utils/formatter';

export interface NewDeductionForm {
    suppId: string;
    riderId: string;
    deductionTypeCode: string;
    deductionName: string;
    deductionAmount: string;
    startDate: string;
    endDate: string;
    deductDays: string;
}

interface RiderToHeadAddRowProps {
    newDeduction: NewDeductionForm;
    supplierOptions: SelectOption[];
    formRiderOptions: SelectOption[];
    deductionTypes: Array<{ code: string; name: string }>;
    deductionTypesLoading: boolean;
    suppliersLoading: boolean;
    formRidersLoading: boolean;
    previewDays: number;
    previewTotal: number;
    onFormSuppIdChange: (suppId: string) => void;
    onRiderChange: (riderId: string) => void;
    onDeductionTypeChange: (code: string, name: string) => void;
    onDeductionNameChange: (name: string) => void;
    onDeductionAmountChange: (amount: string) => void;
    onStartDateChange: (value: string) => void;
    onEndDateChange: (value: string) => void;
    onDeductDaysChange: (value: string) => void;
    onAddDeduction: () => void;
}

const RiderToHeadAddRow: React.FC<RiderToHeadAddRowProps> = ({
                                                                 newDeduction,
                                                                 supplierOptions,
                                                                 formRiderOptions,
                                                                 deductionTypes,
                                                                 deductionTypesLoading,
                                                                 suppliersLoading,
                                                                 formRidersLoading,
                                                                 previewDays,
                                                                 previewTotal,
                                                                 onFormSuppIdChange,
                                                                 onRiderChange,
                                                                 onDeductionTypeChange,
                                                                 onDeductionNameChange,
                                                                 onDeductionAmountChange,
                                                                 onStartDateChange,
                                                                 onEndDateChange,
                                                                 onDeductDaysChange,
                                                                 onAddDeduction,
                                                             }) => (
    <tr className="add-row">
        <td className="text-center text-gray-600">+</td>

        {/* 대상: 협력사 선택 */}
        <td>
            <SearchableSelect
                options={supplierOptions}
                value={newDeduction.suppId}
                onChange={onFormSuppIdChange}
                placeholder="협력사 선택"
                disabled={suppliersLoading}
                showAllOption={true}
                allOptionLabel="선택"
            />
        </td>

        {/* 세부대상: 라이더 선택 */}
        <td>
            <SearchableSelect
                options={formRiderOptions}
                value={newDeduction.riderId}
                onChange={onRiderChange}
                placeholder={formRidersLoading ? '로딩 중...' : '선택'}
                disabled={!newDeduction.suppId || formRidersLoading}
                showAllOption={true}
                allOptionLabel="선택"
            />
        </td>

        {/* 공제타입 */}
        <td>
            <select
                className="form-select"
                value={newDeduction.deductionTypeCode}
                onChange={(e) => {
                    const code = e.target.value;
                    const type = deductionTypes.find(t => t.code === code);
                    onDeductionTypeChange(code, type ? type.name : '');
                }}
                disabled={deductionTypesLoading}
                style={{ width: '100%' }}
            >
                <option value="">{deductionTypesLoading ? '로딩 중...' : '선택'}</option>
                {deductionTypes.map(type => (
                    <option key={type.code} value={type.code}>{type.name}</option>
                ))}
            </select>
        </td>

        {/* 공제명 */}
        <td>
            <input
                type="text"
                className="filter-input"
                value={newDeduction.deductionName}
                onChange={(e) => onDeductionNameChange(e.target.value)}
                placeholder="공제명"
                style={{ width: '100%' }}
            />
        </td>

        {/* 공제금액 */}
        <td>
            <input
                type="text"
                className="filter-input"
                value={formatCurrency(newDeduction.deductionAmount)}
                onChange={(e) => onDeductionAmountChange(e.target.value.replace(/[^0-9]/g, ''))}
                placeholder="금액"
                style={{ textAlign: 'right' }}
            />
        </td>

        {/* 기간 + 일수 입력 */}
        <td>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center', whiteSpace: 'nowrap' }}>
                <DateInput
                    id="riderToHeadNewStartDate"
                    value={newDeduction.startDate}
                    onChange={onStartDateChange}
                />
                <span>~</span>
                <DateInput
                    id="riderToHeadNewEndDate"
                    value={newDeduction.endDate}
                    onChange={onEndDateChange}
                />
                <input
                    type="number"
                    min="1"
                    className="filter-input"
                    value={newDeduction.deductDays}
                    onChange={(e) => onDeductDaysChange(e.target.value)}
                    placeholder="일수"
                    style={{ width: '80px', textAlign: 'center' }}
                />
                <span style={{ fontSize: '12px', color: '#555' }}>일</span>
                {previewDays > 0 && (
                    <span style={{ fontSize: '11px', color: '#1a73e8' }}>
                        {previewTotal > 0
                            ? `(총 ${formatCurrency(String(previewTotal))}원)`
                            : `(${previewDays}일)`}
                    </span>
                )}
            </div>
        </td>

        {/* 등록 버튼 */}
        <td className="text-center">
            <button
                className="btn btn-primary btn-register"
                onClick={onAddDeduction}
            >
                <i className="fas fa-plus-circle" />
            </button>
        </td>
    </tr>
);

export default RiderToHeadAddRow;
